const TEL_KEYWORDS = ["tel", "telephone", "phone", "tel.", "numero de telephone"]
const EMAIL_KEYWORDS = [
  "email",
  "e-mail",
  "mail",
  "courriel",
  "courriel electronique",
  "messagerie",
  "adresse de messagerie",
  "adresse mail",
  "adresse e-mail",
]
const GIVEN_NAME_KEYWORDS = ["prenom", "firstname", "first-name", "givenname", "given-name", "given name"]
const FAMILY_NAME_KEYWORDS = ["nom de famille", "patronyme", "family name", "family-name"]
const STREET_ADDRESS_KEYWORDS = ["adresse", "address", "rue", "street", "voie"]
const POSTAL_CODE_KEYWORDS = ["code postal", "postal code", "postal-code", "code-postal", "zip code", "zipcode"]
const CITY_KEYWORDS = ["ville", "city", "commune", "localite", "localité"]
const PREFIX_KEYWORDS = ["civilite", "civ.", "civi."]
const COUNTRY_KEYWORDS = ["pays", "country", "pays de residence"]

function normalizeFieldName(fieldName: string) {
  return fieldName.toLowerCase().replace(/é/g, "e").trim()
}

function matchesKeywords(fieldName: string, keywords: string[]) {
  return keywords.some(keyword => fieldName.includes(keyword))
}

export function getFieldName(fieldName: string | undefined) {
  if (!fieldName) {
    return undefined
  }

  const normalizedFieldName = normalizeFieldName(fieldName)

  if (matchesKeywords(normalizedFieldName, TEL_KEYWORDS)) {
    return "tel-national"
  }
  if (matchesKeywords(normalizedFieldName, EMAIL_KEYWORDS)) {
    return "email"
  }
  if (matchesKeywords(normalizedFieldName, GIVEN_NAME_KEYWORDS)) {
    return "given-name"
  }
  if (normalizedFieldName === "nom" || matchesKeywords(normalizedFieldName, FAMILY_NAME_KEYWORDS)) {
    return "family-name"
  }
  if (matchesKeywords(normalizedFieldName, STREET_ADDRESS_KEYWORDS)) {
    return "street-address"
  }
  if (matchesKeywords(normalizedFieldName, POSTAL_CODE_KEYWORDS)) {
    return "postal-code"
  }
  if (matchesKeywords(normalizedFieldName, CITY_KEYWORDS)) {
    return "address-level2"
  }
  if (matchesKeywords(normalizedFieldName, PREFIX_KEYWORDS)) {
    return "honorific-prefix"
  }
  if (matchesKeywords(normalizedFieldName, COUNTRY_KEYWORDS)) {
    return "country-name"
  }

  return undefined
}
